export class GameActivity {
    _id: string;
    game_instance: any;
    user: any;
    message: string;
}